import { useFeatureFlag } from '@moda/portal-stanchions';
import { FacadePageType, getRuleContextFromSlug } from '../lib/getRuleContextFromSlug';

export const useRuleVariables = (type: FacadePageType, slug: string) => {
  const areRulesEnabled = useFeatureFlag('use-facade-rules', [
    { default: false },
    { if: true, then: true }
  ]);
  const ruleContext = getRuleContextFromSlug(type, slug);
  const isAbTest = useFeatureFlag(`${ruleContext}_test`, [
    { default: false },
    { if: true, then: true }
  ]);
  return areRulesEnabled
    ? { ruleContexts: [isAbTest ? `${ruleContext}_test` : ruleContext] }
    : null;
};
